import switchstyles from "../../../styles/UI/switch.module.css";
import { useEffect, useRef, useState } from "react";
import { ReactComponent as HeartIcon } from "../../../assets/icons/heart.svg";
import { ReactComponent as XIcon } from "../../../assets/icons/x_grey.svg";
import { ReactComponent as SelectedHeartIcon } from "../../../assets/icons/heart_purple.svg";
import { ReactComponent as SelectedXIcon } from "../../../assets/icons/x_red.svg";
import { ReactComponent as EllipseIcon } from "../../../assets/icons/ellipse.svg";
import api, { API_PATHS } from "../../../service/api";
import {
  PreferrenceData,
  PreferrenceOption,
  PreferrenceStatus,
} from "../../../types/ganttChart";
import { useAppDispatch } from "../../../store/hooks";
import { setNotification } from "../../../store/toastNotifications";

const TrippleSwitch = ({
  index,
  idEmployee,
  idServiceClient,
  status,
  disabled,
}: {
  index: number;
  status: PreferrenceStatus;
  idEmployee: number;
  idServiceClient: number;
  disabled?: boolean;
}) => {
  const dispatch = useAppDispatch();
  const parent = useRef(null);
  const [currentStatus, setCurrentStatus] = useState<PreferrenceStatus>();

  useEffect(() => {
    setCurrentStatus(status);
  }, [status]);

  const updatePreference = async (status: PreferrenceStatus) => {
    try {
      const data: PreferrenceData = {
        idEmployee: idEmployee,
        idServiceClient: idServiceClient,
        employeeFavorabilityCode: status,
      };

      const response = await api.post<any>(API_PATHS.postPreferrence, data);
      if (response) setCurrentStatus(status as PreferrenceStatus);
    } catch {
      dispatch(
        setNotification({
          message: "Vi kunne ikke opdaterer preferrencerne.",
          type: "send_preferrences",
        })
      );
    }
  };

  const options: PreferrenceOption[] = [
    {
      status: "NOT_PREFERRED",
      defaultIcon: <XIcon width={16} height={16} />,
      selectedIcon: <SelectedXIcon width={16} height={16} />,
      backgroundColor: "var(--col-error-2)",
      iconColor: "var(--col-error-3)",
      borderColor: "var(--col-error-primary)",
    },
    {
      status: "NEUTRAL",
      defaultIcon: <EllipseIcon width={4} height={4} />,
      selectedIcon: <EllipseIcon width={4} height={4} />,
      backgroundColor: "var(--col-border-primary)",
      iconColor: "var(--col-graph-first-1)",
      borderColor: "var(--col-border-secondary)",
    },
    {
      status: "PREFERRED",
      defaultIcon: <HeartIcon width={16} height={16} />,
      selectedIcon: <SelectedHeartIcon width={16} height={16} />,
      backgroundColor: "var(--col-graph-third)",
      iconColor: "var(--col-graph-third-2)",
      borderColor: "var(--col-interaction-primary)",
    },
  ];
  return (
    <div className={switchstyles.trippleSwitch}>
      {options.map((option) => (
        <button
          ref={parent}
          style={{
            backgroundColor:
              currentStatus === option.status
                ? option.backgroundColor
                : "transparent",
            border:
              currentStatus === option.status
                ? `1px solid ${option.borderColor}`
                : "transparent",
          }}
          className={`${switchstyles.trippleSwitchButton}`}
          disabled={disabled}
          onClick={() => {
            updatePreference(option.status);
          }}
        >
          {option.status === currentStatus
            ? option.selectedIcon
            : option.defaultIcon}
        </button>
      ))}

      <span className={`${switchstyles.round} ${disabled && switchstyles.disabled}`}></span>

      {currentStatus === "PREFERRED" ? (
        <span className={`${switchstyles.sliderCircleIconLine} ${disabled && switchstyles.disabled}`}></span>
      ) : (
        <span className={`${switchstyles.sliderCircleIconCircle} ${disabled && switchstyles.disabled}`}></span>
      )}
    </div>
  );
};

export default TrippleSwitch;
